<template>
  <iconsWrapper :width="width" :height="height" :viewBox="viewBox">
    <path
      d="M20 24.572L22.908 28L28 22"
      :stroke="iconColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M7.99978 26.0001C7.99978 24.4088 8.63192 22.8827 9.75714 21.7574C10.8824 20.6322 12.4085 20.0001 13.9998 20.0001H17.9998C18.6558 20.0027 19.2804 20.1027 19.8738 20.3001M19.1598 28.6141C16.4122 29.3019 13.5151 29.0735 10.9092 27.9637C8.30334 26.8539 6.13119 24.9234 4.72314 22.4658C3.31509 20.0083 2.74819 17.1581 3.10866 14.3487C3.46913 11.5394 4.73724 8.92462 6.72013 6.90213C8.70302 4.87964 11.2922 3.56007 14.0939 3.14413C16.8955 2.72819 19.7564 3.23863 22.2413 4.59781C24.7263 5.957 26.6993 8.09056 27.8604 10.674C29.0215 13.2575 29.3071 16.1494 28.6738 18.9101M19.9998 12.0001C19.9998 13.0609 19.5784 14.0784 18.8282 14.8285C18.0781 15.5786 17.0606 16.0001 15.9998 16.0001C14.9389 16.0001 13.9215 15.5786 13.1714 14.8285C12.4212 14.0784 11.9998 13.0609 11.9998 12.0001C11.9998 10.9392 12.4212 9.92179 13.1714 9.17165C13.9215 8.4215 14.9389 8.00008 15.9998 8.00008C17.0606 8.00008 18.0781 8.4215 18.8282 9.17165C19.5784 9.92179 19.9998 10.9392 19.9998 12.0001Z"
      :stroke="iconColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
  </iconsWrapper>
</template>

<script>
import iconsWrapper from '@/components/icons/iconsWrapper.vue';
export default {
  name: 'iconAddUser',
  components: {
    iconsWrapper,
  },
  props: {
    iconColor: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 32,
    },
    height: {
      type: [Number, String],
      default: 32,
    },
    viewBox: {
      type: String,
      default: '0 0 32 32',
    },
  },
};
</script>
